<i18n>
{
  "fr": {
    "general": "Général",
    "complianceSurveyOnly": "Enquête de conformité seule",
    "personInCharge": "Personne en charge du dossier :",
    "project": "Adresse du projet",
    "typeOfProperty": "Type de propriété :",
    "numberPolice": "Numéro de police :",
    "contact": "Contact",
    "siret": "N°SIRET :",
    "telephone": "Téléphone :",
    "email": "E-mail :",
    "city": "Ville :",
    "undefined" : "Non renseigné"
  }
}
</i18n>

<template>
  <div id="admin-data" class="block">
    <Content :title="this.$i18n.t('general')">
      <span slot="main-text-1">
        <p class="text">
          <template v-if="this.getValue(property.complianceSurveyOnly)">
              <v-icon name="check"/>
            </template>
            <template v-else>
              <v-icon name="times" class="nok"/>
            </template>
            {{ $t('complianceSurveyOnly') }}
        </p>
      </span>
      <span slot="main-text-2">
        <p class="text">
          {{ $t('personInCharge') }}
          <span>{{ this.getFullName(property) }}</span>
        </p>
      </span>
    </Content>
  </div>
</template>
<script>
import Content from '../Content';
import { mapState } from 'vuex';

export default {
  name: 'AdminData',
  components: {
    Content,
  },
  computed: {
    ...mapState({ property: state => state.refProperties.property }),
  },
  methods: {
    getFullName(property) {
      return (property.responsibleFirstname && property.responsibleLastname) ? `${property.responsibleFirstname} ${property.responsibleLastname}` : this.$i18n.t('undefined');
    },
    getValue(value) {
      return value == 'oui' ? true : false;
    },
  },
};
</script>
